<template>
  <Modal size="md" class="modal" :is-open="isOpen" @close="$emit('close')">
    <HeadingDisplay size="small" title="Disponível para resgate" />

    <div class="modal__list">
      <ListDisplay
        v-for="({ title, value }, index) in availableForRedemption"
        :key="title"
        :has-divider="index !== availableForRedemption.length - 1"
        :title="title"
        :value="value"
      />
    </div>
  </Modal>
</template>

<script lang="ts" setup>
import { IWithdrawDetailsV2 } from '@/modules/transaction/services/product-withdraw';
import { HeadingDisplay, ListDisplay, Modal } from '@warrenbrasil/nebraska-web';
import { computed } from 'vue';

const props = defineProps<{
  isOpen: boolean;
  withdrawDetails: IWithdrawDetailsV2;
}>();

const availableForRedemption = computed(() => [
  {
    title: 'Saldo atual do produto',
    value: props.withdrawDetails.currentBalance
  },
  {
    title: 'Em resgate',
    value: props.withdrawDetails.inRedemption.formatted
  },
  {
    title: 'Aplicações em processamento',
    value: props.withdrawDetails.inProcessing.formatted
  },
  {
    title: 'Saldo disponível para resgate',
    value: props.withdrawDetails.availableToRedemption.formatted
  }
]);
</script>

<style lang="less" scoped>
.modal {
  :deep(.modal-content) {
    padding: 0 @size-spacing-x1000 @size-spacing-x1000 @size-spacing-x1000;
    align-items: flex-start;
    gap: @size-spacing-x700;
  }

  :deep(.base-modal--wrapper) {
    max-width: 592px;
  }

  :deep(.list-display) {
    padding-bottom: @size-spacing-x450;
  }

  :deep(.list-display__text) {
    color: @text-primary !important;
  }

  &__list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x400;
  }
}
</style>
